// extracted by mini-css-extract-plugin
module.exports = {"balanceSpan":"posDashboard_balanceSpan__3E1lb","balanceDisclaimer":"posDashboard_balanceDisclaimer__1rS5a"};